/* tslint:disable */
 
import { ActionInfo } from './action-info';
import { DataEntryFullTextSearch } from './data-entry-full-text-search';
import { ReferenceProperty } from './reference-property';
import { StateHistory } from './state-history';
import { TreeRelationItem } from './tree-relation-item';

/**
 * (tsType: DataEntryTreeDto, schemaOptions: { includeRelations: false })
 */
export class DataEntryTreeDto {
  basedOn?: Array<ReferenceProperty>;
  childrenCount?: number;
  creationInfo?: ActionInfo;
  dataEntity: string;
  entityVersion?: number;
  entryType?: 0 | 1;
  hasChildren?: boolean;
  id?: string;

  /**
   * The reason why the entry is invalid
   */
  invalidReason?: 0 | 1;
  isImplicit?: boolean;

  /**
   * Whether the entry is invalid or not
   */
  isInvalid: boolean;
  lifeCycleStatus?: -1 | 0 | 1;
  relations?: Array<TreeRelationItem>;
  searchIndex?: DataEntryFullTextSearch;
  specificationVersion: number;
  state: 0 | 1 | 2;
  stateHistory?: Array<StateHistory>;
  store?: ReferenceProperty;
  updateInfo?: ActionInfo;
  value: any;
  virtual?: boolean;
}
